export default __webpack_public_path__ + "static/media/Regroup.70af7c5e.svg";